import styled from 'styled-components/macro';

const Container = styled.main`
  position: relative;
  max-width: ${({forceWidth, theme}) => theme.fullWidth && forceWidth !== "slim" ? '100%' : '1360px'};
  margin: 0 auto;
  min-height: 100vh;
  display: flex;
  padding: 0px 16px 0;
  @media only screen and (max-width: 780px) {
    & {
      padding: 0;
    }
  }
`;

export default Container;
